// extracted by mini-css-extract-plugin
module.exports = {"score":"Result_score__2gVds"};